export default "__VITE_ASSET__DxnmokIR__"